/* eslint-disable no-debugger */
import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import layoutComponent from '../views/layout.vue'
import indexComponent from '../components/shouye.vue'
import bsznComponent from "../components/bsznComponent";
import listComponent from "../components/list";
import detailComponent from "../components/detail";
import HomePage from '../views/home.vue'
import LMWH from '../components/lmvh.vue'
import XTSZ from '../components/systemConfig.vue'
import SYLBT from '../components/sylbt.vue'
import TPCLJ from '../components/tpclj.vue'
import WZWH from '../components/wzwh.vue'
import FBTZ from '../components/fbtz.vue'
import FBTZList from '../components/fbtz/fbtzList.vue'
import FBTZAdd from '../components/fbtz/addComponent.vue'
import deptDutyPage from '../components/website/deptDutyPage.vue'
import searchResult from '../components/searchResult.vue'
import deptDutyEdit from '../components/website/deptDutyEdit.vue'
import infoItem from '../components/website/infoItem.vue'
import serviceCenterPage from '../components/website/serviceCenterPage.vue'
import UserManage from '../components/userManage/UserPage.vue'
import WhiteListManage from '../components/whiteListManage/WhiteListManagePage.vue'
import resetPassword from '../components/ResetMyPassword.vue'

Vue.use(VueRouter)
const includPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return includPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/index',
    meta: {
        validate: false
    },
    component: layoutComponent,
    children: [
      {
        path: '/index',
        name: 'index',
        component: indexComponent
      },
      {
        path: '/notice/:id',
        name: 'notice',
        component: bsznComponent,
        children: [
          {
            path: '/list/:id',
            name: 'noticeList',
            component: listComponent
          },
          {
            path: '/detail/:noticeId',
            name: 'noticeDetaile',
            component: detailComponent
          },
        ]
      },
    ]
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPassword
  },
  {
    path: '/search',
    name: 'search',
    component: searchResult
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/manage',
    name: '管理系统首页',
    meta: {
      validate: true
    },
    redirect: '/manage/xtsz',
    component: HomePage,
    children: [
      {
        path: '/manage/xtsz',
        name: '系统设置',
        meta: {
          validate: true
        },
        component: XTSZ
      },
      {
        path: '/manage/website/infoItem',
        name: '信息条目',
        component: infoItem
      },
      {
        path: '/manage/sylbt',
        name: '首页轮播图',
        meta: {
          validate: true
        },
        component: SYLBT
      },
      {
        path: '/manage/tpclj',
        name: '图片超链接',
        meta: {
          validate: true
        },
        component: TPCLJ
      },
      {
        path: '/manage/lmwh',
        name: '栏目维护',
        meta: {
          validate: true
        },
        component: LMWH
      },
      {
        path: '/manage/website/deptDutyPage',
        name: '职责分工',
        meta: {
          validate: true
        },
        component: deptDutyPage
      },
      {
        path: '/manage/website/serviceCenterPage',
        name: '服务中心维护',
        meta: {
          validate: true
        },
        component: serviceCenterPage
      },
      {
        path: '/manage/wzwh',
        name: '文字维护',
        meta: {
          validate: true
        },
        component: WZWH
      },
      {
        path: '/manage/publishNews',
        name: '发布通知',
        meta: {
          validate: true
        },
        redirect: '/manage/publishNews/list',
        component: FBTZ,
        children: [
          {
            path: '/manage/publishNews/list',
            name: '发布通知列表页',
            meta: {
              validate: true
            },
            component: FBTZList
          },
          {
            path: '/manage/publishNews/add',
            name: '发布通知页',
            meta: {
              validate: true
            },
            component: FBTZAdd
          }
        ]
      },
      {
        path: '/manage/userManage',
        name: '用户管理',
        meta: {
          validate: true
        },
        component: UserManage
      },
      {
        path: '/manage/whiteListManage',
        name: '白名单管理',
        meta: {
          validate: true
        },
        component: WhiteListManage
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // if (to.path === '/login') {
  //   next({
  //     path: '/login'
  //   })
  // }
  // if (localStorage.getItem('userInfo')) {
  //   next({
  //     path: '/manage'
  //   })
  // }
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  // 兼容IE
  window.scrollTo(0, 0)
  if (to.meta.validate) {
      if (localStorage.getItem('token')) {
        next()
      } else {
        next({
          path: '/login'
        })
      }
  } else {
    next()
  }
})
export default router
